(() => {
  const groups = () => [...document.querySelectorAll('.brand-nav-group')];
  document.addEventListener('toggle', e => { if (e.target.matches('.brand-nav-group') && e.target.open) groups().forEach(g => { if (g !== e.target) g.open = false; }); }, true);
  document.addEventListener('click', e => { if (!e.target.closest('.brand-nav-group')) groups().forEach(g => { g.open = false; }); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { const open = groups().find(g => g.open); if (open) { open.open = false; open.querySelector('summary').focus(); e.stopImmediatePropagation(); } } });
})();
